/**
 * Gössl Theme - pre-order stock cap in the cart (r188, task #574)
 *
 * Since r187 a size WITH stock goes into the cart without the Vorbestellung plan and sells as an
 * ordinary piece. Without a cap, a second click on "In den Warenkorb" or the + in the cart turned
 * units that do not exist into an ordinary oversold sale (the variants are CONTINUE while in pre-order):
 * no plan, no delivery date, an order that looks like immediate shipping.
 *
 * Rule: a line WITHOUT the plan never holds more units than its size has in stock. capCart() reads
 * the cart through /cart?view=vorrat (templates/cart.vorrat.liquid: per line its plan, its product's
 * Vorbestellung plan by ID and the size's online stock, read fresh) and moves every unit above the
 * stock onto a line WITH the plan - same variant, same properties - so the customer keeps every piece
 * and the extra ones are booked as what they are: pre-orders. Every add path (PDP, quick view, saved
 * outfits, configurator) and every quantity change (drawer, cart page) calls it afterwards.
 *
 * Order per line: reduce first, then add the excess with the plan; if that add fails the line gets its
 * quantity back. A customer never silently loses a piece and never ends up with one twice.
 */
(function () {
  'use strict';

  var g = window.g26preorder = window.g26preorder || {};

  function post(path, body) {
    return fetch(window.g26url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }

  // Liquid's `item.properties | json` is a list of [name, value] pairs; /cart/add.js wants an object.
  function toProps(p) {
    if (!p) return {};
    if (!Array.isArray(p)) return p;
    var o = {};
    p.forEach(function (kv) { if (kv && kv.length === 2) o[kv[0]] = kv[1]; });
    return o;
  }

  // Pure: the moves that bring every no-plan line of a pre-order product within its size's stock.
  // Several no-plan lines of one size (different line properties) share that stock in cart order.
  g.capPlan = function (lines) {
    var bySize = {}, order = [], ops = [];
    (lines || []).forEach(function (l) {
      if (!l || !l.preorder_plan || l.plan || l.stock === null || l.stock === undefined) return;
      var s = bySize[l.variant_id];
      if (!s) { s = bySize[l.variant_id] = { room: Math.max(0, Number(l.stock) || 0), lines: [] }; order.push(s); }
      s.lines.push(l);
    });
    order.forEach(function (s) {
      s.lines.forEach(function (l) {
        var keep = Math.min(l.quantity, s.room);
        s.room -= keep;
        if (l.quantity > keep) {
          ops.push({ key: l.key, variant_id: l.variant_id, keep: keep, excess: l.quantity - keep, plan: l.preorder_plan, properties: toProps(l.properties) });
        }
      });
    });
    return ops;
  };

  function applyOp(op) {
    return post('cart/change.js', { id: op.key, quantity: op.keep })
      .then(function () {
        return post('cart/add.js', { items: [{ id: op.variant_id, quantity: op.excess, selling_plan: op.plan, properties: op.properties }] })
          .catch(function (err) {
            // give the line its units back, then report the failure
            var restore = op.keep > 0
              ? post('cart/change.js', { id: op.key, quantity: op.keep + op.excess })
              : post('cart/add.js', { items: [{ id: op.variant_id, quantity: op.excess, properties: op.properties }] });
            return restore.then(function () { throw err; }, function () { throw err; });
          });
      });
  }

  // Resolves { moved, kept, failed }. Never rejects: a cap that cannot run leaves the cart as it was.
  // One run at a time: a second caller (a + and the checkout button together) reads the cart only after
  // the first has moved its pieces, so no piece is ever moved twice.
  var queue = Promise.resolve();
  g.capCart = function () {
    queue = queue.then(capOnce);
    return queue;
  };

  function capOnce() {
    if (!window.fetch) return Promise.resolve({ moved: 0, kept: 0 });
    // No 'Accept: application/json' here: with it Shopify answers /cart with the plain cart object
    // (as /cart.js) and ignores ?view=, so there are no lines and the cap silently never runs.
    return fetch(window.g26url('cart') + '?view=vorrat&_fd=0')
      .then(function (r) {
        if (!r.ok) throw new Error('cart view ' + r.status);
        return r.json();
      })
      .then(function (d) {
        var ops = g.capPlan(d && d.lines);
        var res = { moved: 0, kept: 0 };
        return ops.reduce(function (p, op) {
          return p.then(function () {
            return applyOp(op).then(function () { res.moved += op.excess; res.kept += op.keep; });
          });
        }, Promise.resolve()).then(function () { return res; });
      })
      .then(function (res) {
        if (res.moved) {
          res.message = res.kept > 0
            ? window.g26t('cart.preorder_split.partial', 'In dieser Größe sind nur {{ count }} Modelle sofort lieferbar – der Rest liegt als Vorbestellung im Warenkorb.', { count: res.kept })
            : window.g26t('cart.preorder_split.none', 'Diese Größe ist nicht mehr sofort lieferbar und liegt jetzt als Vorbestellung im Warenkorb.');
          g.pendingNotice = res.message;
          g.moves = (g.moves || 0) + 1; // lets a checkout door see a move made by a racing call
          document.dispatchEvent(new CustomEvent('cart:preorder-split', { detail: res }));
        }
        return res;
      })
      .catch(function () { return { moved: 0, kept: 0, failed: true }; });
  }
})();
